module.exports = __webpack_public_path__ + "img/D3.7d38be53.jpg";